//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum TargetStatus {
	Untouched = 0,
	Knocked = 1,
	Lost = 2,
	Won = 3,
	GoBack = 4,
	CurrentCustomer = 5,
	ExistingLead = 6,
	CancelledCustomer = 7
}
